export { report } from './@report';
export { default as UndoRedo } from './undoRedo';
export { default as SubmissionTime, PARTICIPATE_STATUS_TEXT } from './@submissionTime/submissionTime';
export { default as shareToClassService } from './shareToClassService';
export { default as referSourceService } from './referSourceService';
export { default as RangeSlider } from './rangeSlider';
export { default as PageSlider } from './pageSlider';
export { default as productionLog } from './productionLog';
export { default as OpenApp } from './openApp';
export { UmuHistory, historySim } from './historySim';
export { downloadFileByOpenWindow, DOWNLOAD_TYPE } from './downloadFileService';
export { default as AudioPlayer } from './audioPlayer';
export { default as playerManager } from './playerManager';
export { default as Page } from './page';
export { PageVisibility } from './pageVisibility';

export { withNotification, eventEmitter } from './notification';
export { getMessageContent } from './@imMsgService/imMsgService';
export { saveComment, commentSaveErrHandle } from './@saveComment/saveComment';
export { setEnterpriseInviteStatus } from "./setEnterpriseInviteStatus";

export { goUserProfile } from "./userService";

export {
    WxShare,
    BaseShare,
    DingdingShare,
    share,
    getShareIcon,
    getDefaultSessionDesc,
    getDefaultSessionTitle,
} from './@share';

import wechatServiceAccount from './@wechatServiceAccount/wechatServiceAccount';

const { follow, commit, checkFollowUmu, getFollowUrl } = wechatServiceAccount;

export { follow, commit, checkFollowUmu, getFollowUrl };

export { onAppShareClick, shareImgForApp } from './share/appShare';

import upload, { expandAccept, expandMediaAccept, getUploadResult } from './uploader/uploader';

export { upload as Uploader, upload, expandAccept, expandMediaAccept, getUploadResult };

export {
    initWebview,
    toggleAppNavBar,
    sendMsgToApp,
    initMsgToApp,
    // SendMsgType,
    // TOOGLE_TYPE,
    FAIL_STATUS,
    SUCCESS_STATUS,
} from './webview';

export { watchPayResult, pay, takeOrder } from './@payService/payService';

export { baseLogger, log, logSearch4, setSearch4BizTagType } from './log';

export {
    getSectionListById,
    getExtraOptionId,
    buildSectionResult,
    getResultListState,
    getSubmitResult,
    getErrorTip,
    validSection,
    combineSectionListWithUserValue,
    combineSectionListWithStatResult,
    transformSectionList,
} from './@pollService/pollService';

export {
    isMergeOptionQuestionRight,
    isOldQuiz,
    getInputQuestionScoreRank,
    getTextQuestionScoreRank,
    getInputQuestionUserAnswer,
    getRightAnswerValue,
    getRightAnswer,
    getUserAnswer,
    getQuizAnswerResult,
    getUserQuizResult,
    SCORE_RANK,
} from './@quizService/quizService';

export {
    redirectToPaidUrl,
    checkEnterpriseAdminPermission,
    redirectToHome,
    redirectToNonWxPayment,
    redirectToCommericalTrial,
    getPlatform,
    redirectToContractSales,
    redirectToCommericalHome,
    redirectToProfessionalHome,
    redirectToPlan,
    redirectToPricing,
    redirectToPurchasePeriodPaymentPayment,
    getPurchasePeriodPaymentUrl,
    redirectToPurchaseAccountQuotaPayment,
    getPurchaseAccountQuotaPaymentUrl,
    redirectToPurchasePayment,
    isBasicVersion,
    isProfessionalVersion,
    PAYMENT_HISTORY_URL,
    INDEX_PAGE,
} from './planPricingService';

export {
    accountDataService,
    REGISTER_BY,
    validateLoginName,
    validatePhone,
    validateMail,
    validatePswd,
    validateNewRulePswd,
    langSwitchList,
    getCurrentLang,
    getCurrentLangValue,
    setSiteLang,
    storageCurrentUserId,
    getUserInfo,
    isEnterpriseUser,
    isEnterpriseAccount,
    isRegisterUser,
    getLoginUrl,
    RECAPTCHA_SITE_KEY,
} from './accountService';
